import type { TranslationTree } from '../../types';

export const administration: TranslationTree = {
  administration: {
    tabs: { members: 'Members', companies: 'Companies' },
    retry: 'Retry',
    roles: { user: 'User', admin: 'Admin', superAdmin: 'Super-admin' },
    errors: {
      generic: 'Something went wrong. Please try again.',
    },
    members: {
      search: 'Search by email or name…',
      roleFilter: 'Filter by role',
      companyFilter: 'Filter by company',
      allRoles: 'All roles',
      allCompanies: 'All companies',
      colMember: 'Member',
      colRole: 'Role',
      colCompany: 'Company',
      colAccess: 'Access',
      colLastLogin: 'Last login',
      colActions: 'Actions',
      empty: 'No members yet — add the first one.',
      you: 'you',
      noModules: 'No modules',
      actions: 'Open member actions',
      locked: 'Protected account',
      lockedSuper: 'Super-admin accounts are managed via the CLI — protected',
      lockedScope: 'Managed by a super-admin',
    },
    member: {
      addTitle: 'Add member',
      addSubtitle: 'Create a new account for this instance.',
      editTitle: 'Edit member',
      add: 'Add member',
      save: 'Save changes',
      edit: 'Edit',
      resetPassword: 'Reset password',
      delete: 'Delete',
      email: 'Email',
      password: 'Password',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      roleHint: "Super-admin is managed via the CLI and can't be set here.",
      company: 'Company',
      access: 'Module access',
      deleteTitle: 'Delete member',
      deleteBody: 'This permanently removes {{email}} and their access. This can’t be undone.',
      confirmDelete: 'Delete member',
    },
    reset: {
      title: 'Reset password',
      body: 'Set a new password for {{email}}.',
      newPassword: 'New password',
      confirm: 'Reset password',
    },
    companies: {
      search: 'Search companies…',
      new: 'New company',
      empty: 'No companies yet — create the first one.',
      colCompany: 'Company',
      colMembers: 'Members',
      colActions: 'Actions',
      members: '{{count}} members',
      rename: 'Rename',
      delete: 'Delete',
    },
    company: {
      createTitle: 'New company',
      renameTitle: 'Rename company',
      name: 'Company name',
      create: 'Create company',
      save: 'Save changes',
      deleteTitle: 'Delete “{{name}}”',
      deleteBody: 'This company has {{count}} members. Choose what happens to them.',
      reassignOption: 'Reassign members, then delete',
      reassignDesc: 'Move all members to another company, then remove this one.',
      reassignTarget: 'Move members to',
      cascadeOption: 'Delete company and its members',
      cascadeDesc:
        'Permanently removes this company and all member accounts. This can’t be undone.',
      warning:
        'Super-admin accounts and your own account are never deleted — the server blocks it. If this company held one, cascade delete is rejected.',
      reassignConfirm: 'Reassign & delete',
      cascadeConfirm: 'Delete everything',
    },
  },
};
